import type { TMSSettingsApi } from './schemas';

export const getDefaultTMSSettings = (): Partial<TMSSettingsApi> => ({
  adminEmail: null,
  allowDraftShipments: null,
  autoRate: null,
  autoTender: null,
  autoTenderAmount: null,
  autoTenderCargoType: null,
  bidExpiryNoOfDays: null,
  brokerageCustomer: null,
  createdBy: null,
  createdOn: null,
  customerKey: null,
  defaultBranchKey: null,
  defaultBusinessJustification: null,
  defaultCargoType: null,
  defaultClass: null,
  defaultEquipmentType: null,
  defaultFobCode: null,
  defaultFreightClass: null,
  defaultHazmat: null,
  defaultHeight: null,
  defaultIncoTerm: null,
  defaultLen: null,
  defaultPackageUom: null,
  defaultPaymentTerms: null,
  defaultProdDesc: null,
  defaultProductCode: null,
  defaultRatingPreferencevalue: null,
  defaultShipmentTerms: null,
  defaultShipmentType: null,
  defaultSpotBidEndStatus: null,
  defaultUom: null,
  defaultWidth: null,
  disableExpiredBids: null,
  displayPO_SOOnShipmentLevel: null,
  emailFrom: null,
  enableMasterOrders: null,
  isCargo: null,
  isCategoryToValidate: null,
  isDefaultRatingPreference: null,
  isDefaultSelected: null,
  isEquipment: null,
  isHideShipmentNumber: null,
  isRequiredApprovalNumber: null,
  isReverseAuction: null,
  isShowRatingDetails: null,
  isvisiablePaidBy: null,
  isWeightCalculation: null,
  maxBidHours: null,
  maximumDays: null,
  maximumDaysErrorMsg: null,
  minimumDays: null,
  minimumDaysErrorMsg: null,
  modifiedBy: null,
  modifiedOn: null,
  nextID: null,
  numberOfRoutingCarrierReturned: null,
  poValidationFlag: null,
  povDestinationMethod: null,
  pricingType: null,
  qtyTolerancePercentage: 10,
  recalculateFreightClass: null,
  routingGuideMatch: null,
  routingMethod: null,
  shipmentApprovalCount: null,
  shipmentApprovalRequired: null,
  shipmentEmailAttachment: null,
  shipmentIdAlphaPrefix: null,
  shipmentIdStartingInteger: null,
  shipmentSupportMail: null,
  shipmentTermsAllowed: null,
  showCurrentBid: null,
  statusInTMS: 'N',
});
